/**
 * DevControls Component
 *
 * Floating dev controls shown only in development mode.
 * Provides a "Next Stage" button to manually advance through stages
 * without waiting for timers.
 */
import React from "react";
import { usePlayer, useGame, useRound } from "@empirica/core/player/classic/react";

export function DevControls() {
  const player = usePlayer();
  const game = useGame();
  const round = useRound();

  const devMode = game?.get("devMode");
  const currentRound = round?.get("current");
  const roundName = round?.get("name");
  const isSubmitted = player?.stage?.get("submit");

  // Only show in dev mode
  if (!devMode) return null;

  const handleNextStage = () => {
    if (player?.stage && !isSubmitted) {
      player.stage.set("submit", true);
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-amber-500 text-white rounded-lg shadow-lg p-3 flex items-center gap-3">
        <div className="text-xs">
          <div className="font-bold">DEV MODE</div>
          <div>Round {currentRound}: {roundName}</div>
        </div>
        <button
          onClick={handleNextStage}
          disabled={isSubmitted}
          className={`px-4 py-2 rounded font-bold transition-all ${
            isSubmitted
              ? "bg-amber-700 text-amber-300 cursor-not-allowed"
              : "bg-white text-amber-600 hover:bg-amber-50 shadow"
          }`}
        >
          {isSubmitted ? "Waiting..." : "Next →"}
        </button>
      </div>
    </div>
  );
}
